import { Link } from "@tanstack/solid-router"
import { Button } from "~/components/ui/button"

export function NotFound({ children }: { children?: any }) {
  return (
    <div class="flex h-screen w-full items-center justify-center bg-gray-50 dark:bg-gray-900">
      <div class="mx-auto max-w-md space-y-6 rounded-lg bg-white p-8 text-center shadow-lg dark:bg-gray-800">
        <div class="space-y-4">
          <h1 class="font-bold text-4xl text-gray-900 dark:text-white">404</h1>
          <div class="text-gray-600 text-lg dark:text-gray-400">
            {children || <p>The page you are looking for does not exist.</p>}
          </div>
        </div>
        <div class="flex flex-wrap items-center justify-center gap-4">
          <Button
            onClick={() => window.history.back()}
            class="rounded-full bg-emerald-500 px-6 py-2 font-semibold text-sm text-white uppercase transition-colors hover:bg-emerald-600"
          >
            Go back
          </Button>
          <Link
            to="/"
            class="rounded-full bg-cyan-600 px-6 py-2 font-semibold text-sm text-white uppercase transition-colors hover:bg-cyan-700"
          >
            Start Over
          </Link>
        </div>
      </div>
    </div>
  )
}
